module.exports = require("tty");;